import * as Yup from "yup"; // Import Yup

export const TAX = process.env.REACT_APP_TAX;
export const PRICE_PER_POINT = process.env.REACT_APP_PRICE_PER_POINT
export const STRIPE_CLIENT = process.env.REACT_APP_STRIPE_CLIENT_SECRET

export const MAX_VALUE = process.env.REACT_APP_MAX_BUY_POINTS

export const calculateTax = (amount) => {
    if(!amount) return 0;
    return (amount * ((TAX)/ 100)).toFixed(2)
}

export const pointsValidationSchema = Yup.object().shape({
    points: Yup.number()
                .transform((value, originalValue) => (originalValue.trim() === "" ? null : value)) // Convert empty string to null
                .nullable() // Allow null values for validation
                .required("Points are required")
                .typeError("Points must be a number") // Handle non-numeric inputs
                .max(MAX_VALUE, "Points must be less than or equal to " + MAX_VALUE)
                .min(100, "Points must be greater than or equal to 100")
                .test(
                    "is-multiple-of-100",
                    "Points must be a multiple of 100",
                    (value) => value === null || value % 100 === 0
                ),
});